module.exports = __webpack_public_path__ + "static/media/light_fixture_wall_zku.f9fcee26.png";